import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Zap, ShieldCheck, Receipt, LineChart } from 'lucide-react';
const BENEFITS = [{
  icon: <TrendingUp className="w-6 h-6" data-id="element-28" />,
  title: '+37% lift in collection rate',
  desc: 'Pilot retailers see a measurable jump in on-time account settlements within the first 90 days.',
  big: true
}, {
  icon: <Users className="w-6 h-6" data-id="element-29" />,
  title: 'Reach 12M+ unbanked & app-averse customers',
  desc: 'USSD and WhatsApp work on every phone, on every network, with or without data.'
}, {
  icon: <Zap className="w-6 h-6" data-id="element-30" />,
  title: 'Same-day PayShap settlement',
  desc: 'Funds settle to your bank in under 60 seconds. Reconciliation files drop daily.'
}, {
  icon: <Receipt className="w-6 h-6" data-id="element-31" />,
  title: 'Cut in-store payment costs by 80%',
  desc: 'Take the cash-handling load off your tills and free your floor staff for selling.'
}, {
  icon: <ShieldCheck className="w-6 h-6" data-id="element-32" />,
  title: 'Built-in fraud & SIM-swap protection',
  desc: 'Every payment is verified against MNO records. Disputes drop, chargebacks vanish.'
}, {
  icon: <LineChart className="w-6 h-6" data-id="element-33" />,
  title: 'Real-time dashboard & reporting',
  desc: 'Collections, channels, cohorts, and arrears — visible to finance, ops, and merchandising.'
}];
export function Benefits() {
  return <section id="benefits" className="py-24 bg-ink" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="max-w-3xl mb-16" data-id="element-36">
          <div className="text-xs font-medium uppercase tracking-[0.2em] text-mint mb-4" data-id="element-37">
            Why retailers choose Masube
          </div>
          <h2 className="display text-bone mb-6" style={{
          fontSize: 'clamp(2.25rem, 5vw, 4rem)'
        }} data-id="element-38">
            
            Built for{' '}
            <span className="display-italic text-mint" data-id="element-39">credit retail</span>, not
            generic payments.
          </h2>
          <p className="text-lg text-bone-dim leading-relaxed" data-id="element-40">
            Masube is the only payment orchestration layer in South Africa
            designed for the realities of store-card collections — not just
            card-not-present checkout.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-fr" data-id="element-41">
          {BENEFITS.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07
        }} className={`group relative rounded-3xl p-8 border transition-all overflow-hidden ${b.big ? 'lg:col-span-2 lg:row-span-1 bg-mint text-ink border-mint hover:bg-mint-dim' : 'bg-ink-2 text-bone border-white/5 hover:border-mint/30'}`} data-id="element-42">
            
              <div className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 ${b.big ? 'bg-ink/15 text-ink' : 'bg-mint-soft text-mint'}`} data-id="element-43">
              
                {b.icon}
              </div>
              <h3 className={`text-2xl font-semibold mb-3 tracking-tight ${b.big ? 'text-ink' : 'text-bone'}`} data-id="element-44">
              
                {b.title}
              </h3>
              <p className={`text-base leading-relaxed ${b.big ? 'text-ink/80' : 'text-bone-dim'}`} data-id="element-45">
              
                {b.desc}
              </p>

              {b.big && <div className="mt-8 pt-6 border-t border-ink/15 flex items-center gap-8" data-id="element-46">
                  <div data-id="element-47">
                    <div className="display text-ink text-4xl" data-id="element-48">+37%</div>
                    <div className="text-xs text-ink/70 uppercase tracking-wider mt-1" data-id="element-49">
                      Collections
                    </div>
                  </div>
                  <div data-id="element-50">
                    <div className="display text-ink text-4xl" data-id="element-51">-80%</div>
                    <div className="text-xs text-ink/70 uppercase tracking-wider mt-1" data-id="element-52">
                      Till cost
                    </div>
                  </div>
                  <div data-id="element-53">
                    <div className="display text-ink text-4xl" data-id="element-54">14d</div>
                    <div className="text-xs text-ink/70 uppercase tracking-wider mt-1" data-id="element-55">
                      To go live
                    </div>
                  </div>
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}